var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"supports col-md-12"},[_c('ListTickets',{attrs:{"filter_asc":_vm.filter_asc,"filter_type":_vm.filter_type,"tickets":_vm.tickets,"show_new_ticket":false},on:{"check_link":_vm.checker,"change_filter":_vm.change_filter,"change_list":_vm.change_list,"clear_list":_vm.clear_list}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }